const resource = 'api/deliverymen';
export default ($http) => ({
  listAllDeliverymen() {
    return $http.get(`${resource}/`);
  },
});
